<mat-tab-group [selectedIndex]="selectedIndex" (selectedTabChange)="tabChanged($event)">
  <mat-tab label="Summary" >
    <ng-template matTabContent>
        <app-summary></app-summary>
    </ng-template>
  </mat-tab>
  <mat-tab label="Detail" *ngIf="Detail.length > 0">
    <ng-template matTabContent>
      <app-subtabs-component [subpages]="Detail"></app-subtabs-component>
    </ng-template>
  </mat-tab>
  <mat-tab label="Unknown Status" *ngIf="Unavailable.length > 0">
    <ng-template matTabContent>
      <app-subtabs-component [subpages]="Unavailable"></app-subtabs-component>
    </ng-template>
  </mat-tab>
</mat-tab-group>
